export default "__VITE_ASSET__nhhxMgWqR96kwjvmOFM8oQ__"